import React from 'react'
import Header from '../Components/Header'
import ResultComponent from '../Components/Assessment/Testarea/Result'

const Result = () => {
  return (
    <div>
      <Header/>
      <ResultComponent/>
    </div>
  )
}

export default Result
